import React from "react";
import { PagePropsContext } from "./Homepage.contexts";

export function PagePropsProvider({
  categories,
  categoryStories,
  latestStories,
  tags,
  children,
}) {
  return (
    <PagePropsContext.Provider
      value={{ categories, categoryStories, latestStories, tags }}
    >
      {children}
    </PagePropsContext.Provider>
  );
}
